var map = {
	"./template.betgalaxy": 2103,
	"./template.betgalaxy.tsx": 2103,
	"./template.betprofessor": 1061,
	"./template.betprofessor.tsx": 1061,
	"./template.betroyale": 1062,
	"./template.betroyale.tsx": 1062,
	"./template.default": 654,
	"./template.default.tsx": 654,
	"./template.fiestabet": 1063,
	"./template.fiestabet.tsx": 1063,
	"./template.puntcity": 1064,
	"./template.puntcity.tsx": 1064,
	"./template.puntgenie": 1065,
	"./template.puntgenie.tsx": 1065,
	"./template.questbet": 1066,
	"./template.questbet.tsx": 1066,
	"./template.ts": 964,
	"./template.volcanobet": 1067,
	"./template.volcanobet.tsx": 1067,
	"./template.wellbet": 1068,
	"./template.wellbet.tsx": 1068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2411;